import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../../components/shared/PageHeader/PageHeader';
import EmptyState from '../../../components/shared/EmptyState/EmptyState';
import Button from '../../../components/shared/Button/Button';

const ManifestPlaceholder: React.FC = () => {
  return (
    <>
      <PageHeader title="Manifest" description="View a trip's manifest." />
      <EmptyState
        title="No trip selected"
        description="Open a trip from the Trips page to see its passenger manifest."
        action={
          <Link to="/admin/operations/trips">
            <Button variant="primary">Go to Trips</Button>
          </Link>
        }
      />
    </>
  );
};

export default ManifestPlaceholder;
